import { FiChevronDown } from "react-icons/fi";
import { components } from "react-select";
import { EVV_COLORS } from "src/utils/colors";

const LobbieSelectDropdownIndicator = (props: any) => {
    return (
        <components.DropdownIndicator {...props}>
            <FiChevronDown
                className="gray1 rounded-circle mt-1 mb-1 ml-auto"
                style={{ background: EVV_COLORS.blackTransparant }}
                size="1em"
                strokeWidth={3}
            />{" "}
        </components.DropdownIndicator>
    );
};

export default LobbieSelectDropdownIndicator;
